module.exports = __webpack_public_path__ + "static/media/lights.4e821175.svg";